import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
// Actions
import {
  SG_GET_TASK_SCHEDULES,
  SG_GET_TASK_TEMPLATES,
  SG_GET_TASK_TEMPLATE_SELECT,
} from "constants/actions";

// Pages
import LandingPage from "./LandingPage";
import SurveyFormPage from "./SurveyFormPage";
import SelectionPage from "./SelectionPage";
import PulseBuilderPage from "./PulseBuilderPage";
import PulseLibraryPage from "./PulseLibraryPage";
import PulseDataViewPage from "./PulseDataViewPage";
import PulseAnalytics from "./PulseAnalytics";
import EmptyPage from "./EmptyPage";
import { usePulseSurveys, PulseSurveysProvider } from "./Data/LandingPageContext";

const PulseSurveyContent = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [currentView, setCurrentView] = useState();
  const { surveyData } = usePulseSurveys();

  

  // Define navigateToForm function
  const navigateToForm = (survey) => {
    navigate("/app/otp/AI/pulse-survey/create", {
      state: { initialSurveyData: survey }, // survey contains only serializable fields
    });
  };

  const { scheduledPulseSurveys, allPulseSurveys, get_auth, pulseFetched } =
    useSelector(
      (state) => ({
        scheduledPulseSurveys: state.task_templates.scheduled_tasks,
        allPulseSurveys: state.task_templates.task_templates,
        get_auth: state.auth,
        pulseFetched: state.task_templates.surveysFetched,
      }),
      shallowEqual
    );

  useEffect(() => {
    dispatch({ type: SG_GET_TASK_TEMPLATE_SELECT });
    dispatch({ type: SG_GET_TASK_SCHEDULES });
    dispatch({ type: SG_GET_TASK_TEMPLATES });
  }, [dispatch]);

  useEffect(() => {
    // add these to the regex, separated by a |
    const pathList = [
      "create",
      "edit",
      "view",
      "analytics",
      "survey-selection",
      "builder",
      "survey-library",
    ];
    const regex = new RegExp(
      `^/app/otp/AI/pulse-survey/(?:(${pathList.join("|")})(?:/(\\d+))?)?$`
    );

    console.log(location.pathname);

    const match = location.pathname.match(regex);

    if (match) {
      const operation = match[1]; // "create", "edit", or "view"
      const id = match[2]; // ID if present

      switch (operation) {
        case "survey-selection":
          setCurrentView(<SelectionPage />);
          break;

        case "survey-library":
          setCurrentView(<PulseLibraryPage navigateToForm={navigateToForm} />);
          break;

        case "builder":
          setCurrentView(<PulseBuilderPage navigateToForm={navigateToForm} />);
          break;

        case "create":
          setCurrentView(<SurveyFormPage mode="create" />);
          break;

        case "edit":
          setCurrentView(<SurveyFormPage mode="edit" surveyId={id} />);
          break;

        case "view":
          setCurrentView(<PulseDataViewPage surveyId={id} />);
          break;

        case "analytics":
          setCurrentView(<PulseAnalytics surveyId={id} />);
          break;

        default:
          if (!scheduledPulseSurveys?.results && !allPulseSurveys?.results) {
            setCurrentView(null);
            return;
          }

          if (pulseFetched && surveyData?.length === 0) {
            setCurrentView(<EmptyPage />);
          } else {
            setCurrentView(<LandingPage />);
          }
          break;
      }
    } else {
      if (!scheduledPulseSurveys?.results && !allPulseSurveys?.results) {
        setCurrentView(null);
        return;
      }

      if (pulseFetched && surveyData?.length === 0) {
        setCurrentView(<EmptyPage />);
      } else {
        setCurrentView(<LandingPage />);
      }
    }
  }, [location.pathname, scheduledPulseSurveys, allPulseSurveys, pulseFetched, surveyData]);

  if (!currentView) {
    return null;
  }

  return currentView;
};

const PulseSurvey = () => {
  return (
    <PulseSurveysProvider>
      <PulseSurveyContent />
    </PulseSurveysProvider>
  );
};

export default PulseSurvey;
